let shared: AudioContext | null = null;

function context(): AudioContext | null {
  const Ctx = window.AudioContext || (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctx) return null;
  if (!shared) shared = new Ctx();
  return shared;
}

function blip(ctx: AudioContext, start: number, frequency: number) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'triangle';
  osc.frequency.setValueAtTime(frequency, start);
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(0.18, start + 0.012);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.09);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(start);
  osc.stop(start + 0.1);
}

/** Two short descending tones. Call from a tap so the phone will play it. */
export function playNotAllowed() {
  const ctx = context();
  if (!ctx) return;
  const start = () => {
    const now = ctx.currentTime;
    blip(ctx, now, 320);
    blip(ctx, now + 0.11, 180);
  };
  if (ctx.state === 'suspended') {
    ctx.resume().then(start).catch(() => {});
    return;
  }
  start();
}
